import { render, staticRenderFns } from "./BatchesUsers.vue?vue&type=template&id=76894865&lang=true&"
import script from "./BatchesUsers.vue?vue&type=script&lang=js&"
export * from "./BatchesUsers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports